/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const subscriptionCheckoutDataStatusSchema = z.enum(['active', 'requires_action'])

export type SubscriptionCheckoutDataStatusSchema = z.infer<typeof subscriptionCheckoutDataStatusSchema>
